import JumbotronSeries from './JumbotronSeries'

export default JumbotronSeries
// eslint-disable-next-line import/export
export * from './JumbotronSeries'
